import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";

const ContactManager = () => {
  const navigate = useNavigate();
  const BaseURL = "https://api.sidharthsogani.com/api";
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [modalType, setModalType] = useState("delete");
  const [currentContact, setCurrentContact] = useState(null);
  const tableRef = useRef(null);

  useEffect(() => {
    const token = sessionStorage.getItem("AdminAuthToken");
    if (!token) navigate("/");
  }, [navigate]);

  const fetchContacts = async () => {
    try {
      const token = sessionStorage.getItem("AdminAuthToken");
      const res = await fetch(`${BaseURL}/contact`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      if (!res.ok) throw new Error("Failed to fetch contacts");
      
      const data = await res.json();
      if (data.success) {
        const formattedData = data.data.map(item => ({
          ...item,
          created_at: formatApiDate(item.created_at)
        })).reverse();
        
        setContactList(formattedData);
      } else {
        throw new Error(data.message || "Failed to fetch contacts");
      }
      
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const formatApiDate = (dateString) => {
    if (!dateString) return null;
    
    if (dateString.includes('T')) {
      const dateObj = new Date(dateString);
      return dateObj.toLocaleString();
    }
    
    return dateString;
  };

  const truncateText = (text, length = 20) => {
    if (!text) return 'N/A';
    return text.length > length ? `${text.substring(0, length)}...` : text;
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  useEffect(() => {
    if (contactList.length > 0) {
      const table = $("#dataTable").DataTable({ destroy: true });
      return () => {
        table.destroy();
      };
    }
  }, [contactList]);

  const handleView = (contact) => {
    setCurrentContact(contact);
    setShowDetailModal(true);
  };

  const handleDelete = async () => {
    const token = sessionStorage.getItem("AdminAuthToken");
    
    try {
      const res = await fetch(`${BaseURL}/contact/${currentContact.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) throw new Error("Failed to delete contact");
      
      const result = await res.json();
      if (result.success) {
        NotificationManager.success("Contact deleted successfully");
        await fetchContacts();
        setShowModal(false);
      } else {
        throw new Error(result.message || "Failed to delete contact");
      }
    } catch (err) {
      NotificationManager.error(err.message);
    }
  };

  if (loading) return <div className="text-center py-4">Loading...</div>;
  if (error) return <div className="alert alert-danger">Error: {error}</div>;

  return (
    <div className="card basic-data-table">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5>Contact Messages</h5>
        </div>

        <div className="table-responsive">
          {contactList.length > 0 ? (
            <table 
              ref={tableRef}
              className="table bordered-table mb-0" 
              id="dataTable"
              data-page-length={10}
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Message</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {contactList.map((contact, idx) => (
                  <tr key={contact.id}>
                    <td>{idx + 1}</td>
                    <td>{contact.name || 'N/A'}</td>
                    <td>{truncateText(contact.email) || 'N/A'}</td>
                    <td>{contact.mobile_number || 'N/A'}</td>
                    <td>{truncateText(contact.message, 30) || 'N/A'}</td>
                    <td>{contact.created_at || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="alert alert-info">
              No contact messages found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactManager;